import { useMemo } from 'react';
import { useOpts } from '../context';
import { useGetLocalizedString } from './useGetLocalizedString';
import { selectIsCompanyConnectJob } from '../state/slices/slice-link-params';
import { useAppSelector } from '../state';
import useOrgName from './useOrgName';
// TODO: Need to replace this with a COPY MGMT SYSTEM
export default function useTerminalScreenButtonText() {
    var getLocalizedString = useGetLocalizedString();
    var sdk = useOpts().sdk;
    var isCompanyConnectJob = useAppSelector(selectIsCompanyConnectJob);
    var orgName = useOrgName();
    var buttonLabel = useMemo(function () {
        if (sdk === 'standalone-site') {
            return getLocalizedString('CONTINUE');
        }
        if (isCompanyConnectJob) {
            return getLocalizedString('RETURN_TO_BANKAPP', [orgName]);
        }
        return getLocalizedString('CLOSE');
    }, [getLocalizedString, sdk, isCompanyConnectJob, orgName]);
    return buttonLabel;
}
